module.exports = __webpack_public_path__ + "img/maelstrom.3be9e89c.svg";